import React from 'react';
import { ShimmerCircularImage, ShimmerTitle, ShimmerThumbnail } from "react-shimmer-effects";
import { BaseCard } from '../commonComponents';

const InvoiceLoader = () => {

  const renderBalanceTextLoader = () => {
    return (
      <div style={{ width: '150px' }}>
        <ShimmerThumbnail height={13} className="rounded-3 mb-0" />
      </div>
    )
  }

  const renderBalanceAmountLoader = () => {
    return (
      <div style={{ width: '40px' }}>
        <ShimmerThumbnail height={13} className="rounded-3 mb-0" />
      </div>
    )
  }

  const renderPayNowBtnLoader = () => {
    return (
      <div style={{ width: '100%' }}>
        <ShimmerThumbnail height={42} className="rounded-3 mb-0" />
      </div>
    )
  }

  return (
    <>
      <div className='mg-t-20 flex-1'>
        <BaseCard
          customBaseCardStyle='pd-15 mg-b-15'
        >
          <div className='position-relative'>
            <div className='d-flex mg-b-20'>
              <div className='fs-14 text-black flex-1'>{renderBalanceTextLoader()}</div>
              <div className='fs-20 fw-semibold text-black text-end'>{renderBalanceAmountLoader()}</div>
            </div>
            <div className='d-flex mg-b-20'>
              <div className='fs-14 text-black flex-1'>{renderBalanceTextLoader()}</div>
              <div className='fs-14 fw-semibold text-black text-end'>{renderBalanceAmountLoader()}</div>
            </div>
          </div>
          <div className='d-flex align-items-center'>
            {renderPayNowBtnLoader()}
          </div>
        </BaseCard>
      </div>
      {
        Array.from({ length: 10 }).map(_ => {
          return (
            <BaseCard customBaseCardStyle='mg-t-15 rounded-3'>
              <div className='d-flex align-items-center'>
                <div className="d-flex align-items-center flex-1">
                  <div className='shimmer-circular-img'><ShimmerCircularImage size={30} className="flex-1 mg-b-0" /></div>
                  <div className='mg-l-10'>
                    <div style={{ width: '100px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
                    <div style={{ width: '75px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block mg-t-5" /></div>
                  </div>
                </div>
                <div className='d-flex flex-column align-items-end'>
                  <div style={{ width: '60px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
                  <div style={{ width: '100px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block mg-t-5" /></div>
                </div>
              </div>
            </BaseCard>
          );
        })
      }
    </>
  );
};

export default InvoiceLoader;
